/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Legal_Entity_EmailInputs */

const cs_auth_signup_legal_entity_email = /** @type {(inputs: Auth_Signup_Legal_Entity_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const en_auth_signup_legal_entity_email = /** @type {(inputs: Auth_Signup_Legal_Entity_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Auth_Signup_Legal_Entity_EmailInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_legal_entity_email = /** @type {((inputs?: Auth_Signup_Legal_Entity_EmailInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Legal_Entity_EmailInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_legal_entity_email(inputs)
	return cs_auth_signup_legal_entity_email(inputs)
});